import { createTheme } from '@mui/material/styles';


export const newHFLThemeVars = {
  '--Text-Default-Primary': '#280F1C',
  '--text-on-cta-primary': '#FFF',
  '--Border-Default-Primary': '#280F1C',
  '--Icon-Default-Primary': '#280F1C',
  '--Background-CTA-Primary': '#185AEE',
  '--Background-CTA-Invert': '#FFF',
  '--Background-Default-Secondary': '#F2F2F2',
  '--sds-typography-family-sans': "'TWK Lausanne', sans-serif",
  '--sds-typography-family-serif': "'ABC Marist', serif",
  '--Scale-06': '62px',
  '--Scale-01': '20px',
  '--scale-00-base': '18px',
  '--Scale--01': '14px',
} as const;

const FONT_SANS = 'var(--sds-typography-family-sans, "TWK Lausanne", sans-serif)';
const FONT_SERIF = 'var(--sds-typography-family-serif, "ABC Marist", serif)';
const TEXT_PRIMARY = 'var(--Text-Default-Primary, #280F1C)';

const TEXT_PRIMARY_COLOR = newHFLThemeVars['--Text-Default-Primary'];


export const newHFLTheme = createTheme({
  palette: {
    mode: 'light',
    text: {
      primary: TEXT_PRIMARY_COLOR,
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: FONT_SANS,
  },
  components: {
    MuiTypography: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiButton: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiInputBase: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiFormLabel: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiFormHelperText: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiMenuItem: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiLink: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
    MuiCheckbox: { styleOverrides: { root: { fontFamily: FONT_SANS } } },
  },
});


export const newHFLTypography = {
  headingXXL: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SANS,
    fontSize: { xs: '40px', md: 'var(--Scale-06, 62px)' },
    fontStyle: 'normal',
    fontWeight: 250,
    lineHeight: '100%',
    letterSpacing: '-1.86px',
  },
  bodyL: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SERIF,
    fontSize: 'var(--Scale-01, 20px)',
    fontStyle: 'normal',
    fontWeight: 350,
    lineHeight: '120%',
  },
  bodyM: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SERIF,
    fontSize: 'var(--scale-00-base, 18px)',
    fontStyle: 'normal',
    fontWeight: 350,
    lineHeight: '125%',
  },
  eyebrowM: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SANS,
    fontSize: 'var(--Scale-01, 20px)',
    fontStyle: 'normal',
    fontWeight: 250,
    lineHeight: '140%',
    textTransform: 'uppercase',
  },
  ctaM: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SANS,
    fontSize: 'var(--scale-00-base, 18px)',
    fontStyle: 'normal',
    fontWeight: 250,
    lineHeight: '120%',
  },
  ctaS: {
    color: TEXT_PRIMARY,
    fontFamily: FONT_SANS,
    fontSize: 'var(--Scale--01, 14px)',
    fontStyle: 'normal',
    fontWeight: 250,
    lineHeight: '120%',
  },
};
